
export default {
    intervals: {},
    departments: {},
    goals: {},
    budgets: {},
    incomes: {}
}
